module.exports = __webpack_public_path__ + "static/media/lightful_logo_white.3622c477.svg";